<script lang="ts">
  import ModalSimple from '$components/modal/ModalSimple.svelte';
  import Button from '$components/button/Button.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import InputText from '$components/input-text/InputText.svelte';
  import { stateCirclesRpcEndpoint } from '$states/circlesRpcEndpoint.svelte';

  let endpoint = $state<string>('');

  const confirm = async (): Promise<void> => {
    stateCirclesRpcEndpoint.change(endpoint);
    closeModal();
  };
</script>

<ModalSimple>
  {#snippet title()}
    Switch Circles RPC Endpoint
  {/snippet}
  {#snippet paragraph()}
    Enter https endpoint here:
    <div class="relative z-20">
      <InputText bind:value={endpoint} name="endpoint" placeholder="https://rpc.aboutcircles.com/"
      ></InputText>
    </div>
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Confirm" variant="success" onclick={confirm}>Confirm</Button>
    <Button ariaLabel="Cancel" variant="secondary" onclick={() => closeModal()}>Cancel</Button>
  {/snippet}
</ModalSimple>
